// extracted by mini-css-extract-plugin
module.exports = {"container":"relatedArticles_container__MneD4","title":"relatedArticles_title__1M_4b"};